import PageTitle from 'components/pageTitle';

import * as S from './styles';

export default function AccessPage() {
  return (
    <S.Container>
      <PageTitle title="No access" />
      <S.Message>You do not have access to this page.</S.Message>
    </S.Container>
  );
}
